export const WorkingMode = {
    HTM01: 0,
    ISO: 1
}